import React from 'react';

const Devices = () => {
  return (
    <section id="devices" className="section-padding bg-white">
      <div className="container-max">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Extraoral & Intraoral Devices</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Custom-built UV imaging devices designed for optimal dental disease detection—engineered for both extraoral and intraoral use.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Extraoral Device */}
          <div className="flex flex-col items-center bg-gray-50 rounded-2xl py-6 md:py-8 shadow-lg">
            <img 
              src="/images/technology/extraoral-exploded.png" 
              alt="Extraoral Device Exploded Diagram" 
              className="w-full max-w-xl h-auto mb-6 rounded-xl shadow"
            />
            <h3 className="text-2xl font-semibold text-gray-900 mb-2">Extraoral Device</h3>
            <p className="text-gray-600 text-center">
              Designed for external imaging of the mouth, this device uses 405nm UV LEDs and precision optics to capture high-resolution images for AI analysis.
            </p>
          </div>
          {/* Intraoral Device */}
          <div className="flex flex-col items-center bg-gray-50 rounded-2xl py-6 md:py-8 shadow-lg">
            <img 
              src="/images/technology/intraoral-exploded.png" 
              alt="Intraoral Device Exploded Diagram" 
              className="w-full max-w-xl h-auto mb-6 rounded-xl shadow"
            />
            <h3 className="text-2xl font-semibold text-gray-900 mb-2">Intraoral Device</h3>
            <p className="text-gray-600 text-center">
              Compact and ergonomic, this device is optimized for internal mouth imaging, enabling detailed detection of plaque and gingivitis in hard-to-reach areas.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Devices; 